var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { inline: false, "label-position": "top", size: "small" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("navbar.restrictionState") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            "collapse-tags": "",
                            filterable: "",
                            multiple: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleState(
                                _vm.queryForm.params.restrictionStateList,
                                2
                              )
                            },
                            clear: _vm.clear1,
                          },
                          model: {
                            value: _vm.queryForm.params.restrictionStateList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "restrictionStateList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.restrictionStateList",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.tudo"),
                              value: "all",
                            },
                          }),
                          _vm._l(_vm.StateList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.label, value: item.label },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("navbar.restrictionSiteId") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.all"),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.restrictionSiteIdList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "restrictionSiteIdList",
                                $$v
                              )
                            },
                            expression:
                              "queryForm.params.restrictionSiteIdList",
                          },
                        },
                        _vm._l(_vm.siteList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.status") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          },
                          model: {
                            value: _vm.queryForm.params.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "status", $$v)
                            },
                            expression: "queryForm.params.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.enable"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.stop"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.Type") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          },
                          model: {
                            value: _vm.queryForm.params.restrictionType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "restrictionType",
                                $$v
                              )
                            },
                            expression: "queryForm.params.restrictionType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("navbar.dainziweilan"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("navbar.qiangzhiyanzhengma"),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("navbar.qiangzhiqinashou"),
                              value: 3,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("navbar.RestrictedAccounts"),
                        prop: "userIdList",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.OnlyAreDisplayed"
                            ),
                            "remote-method": _vm.getAllUserList,
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            "visible-change": function ($event) {
                              return _vm.getAllUserList()
                            },
                          },
                          model: {
                            value: _vm.queryForm.params.userIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "userIdList", $$v)
                            },
                            expression: "queryForm.params.userIdList",
                          },
                        },
                        _vm._l(_vm.accountList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.username, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.enterSearch },
            },
            [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                icon: "el-icon-refresh-left",
                size: "small",
                type: "info",
              },
              on: {
                click: function ($event) {
                  return _vm.resetForm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit:remove",
                  value: "btn:qualityService:SignLimitConfiguration:add",
                  expression: "'btn:qualityService:SignLimitConfiguration:add'",
                  arg: "remove",
                },
              ],
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.newRestrictions },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.add")) + " ")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit:remove",
                  value: "btn:qualityService:SignLimitConfiguration:enable",
                  expression:
                    "'btn:qualityService:SignLimitConfiguration:enable'",
                  arg: "remove",
                },
              ],
              attrs: { plain: "", size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.statusBtn(1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.enable")) + " ")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit:remove",
                  value: "btn:qualityService:SignLimitConfiguration:stop",
                  expression:
                    "'btn:qualityService:SignLimitConfiguration:stop'",
                  arg: "remove",
                },
              ],
              attrs: { plain: "", size: "small", type: "danger" },
              on: {
                click: function ($event) {
                  return _vm.statusBtn(0)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.stop")) + " ")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.exportsTable } },
            [_vm._v(_vm._s(_vm.$t("operationCenter.exports")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "70",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                align: item.cloAlign,
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "isElectronicFenceName"
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  style: {
                                    color: scope.row.isElectronicFence
                                      ? "#00A551"
                                      : "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.isElectronicFenceName) +
                                      " "
                                  ),
                                ]
                              ),
                            ])
                          : item.prop === "isCaptchaName"
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  style: {
                                    color: scope.row.isCaptcha
                                      ? "#00A551"
                                      : "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(scope.row.isCaptchaName) + " "
                                  ),
                                ]
                              ),
                            ])
                          : item.prop === "isDeliverImgName"
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  style: {
                                    color: scope.row.isDeliverImg
                                      ? "#00A551"
                                      : "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.isDeliverImgName) +
                                      " "
                                  ),
                                ]
                              ),
                            ])
                          : item.prop === "statusName"
                          ? _c(
                              "div",
                              [
                                scope.row.status === 1
                                  ? _c("el-tag", [
                                      _vm._v(_vm._s(scope.row.statusName)),
                                    ])
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v(_vm._s(scope.row.statusName))]
                                    ),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop]
                                    ? "" + scope.row[item.prop]
                                    : "- -"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("newOrder.operation"),
              align: "center",
              fixed: "right",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-around",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.edit"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-edit textOperator",
                              on: {
                                click: function ($event) {
                                  return _vm.editData(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        scope.row.status === 0
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.enable"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "btn:qualityService:SignLimitConfiguration:enable",
                                      expression:
                                        "'btn:qualityService:SignLimitConfiguration:enable'",
                                      arg: "remove",
                                    },
                                  ],
                                  staticClass:
                                    "el-icon-circle-check textOperator",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.stop"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "btn:qualityService:SignLimitConfiguration:stop",
                                      expression:
                                        "'btn:qualityService:SignLimitConfiguration:stop'",
                                      arg: "remove",
                                    },
                                  ],
                                  staticClass:
                                    "el-icon-remove-outline textOperator1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 20, 50, 100],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.dialogTitle,
            visible: _vm.addDialog,
            top: "5vh",
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
            close: _vm.handleAddCusTimeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-position": "top",
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("navbar.restrictionState"),
                    prop: "restrictionState",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        clearable: "",
                        filterable: "",
                        multiple: "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleState(
                            _vm.ruleForm.restrictionState,
                            1
                          )
                        },
                        clear: _vm.clear2,
                      },
                      model: {
                        value: _vm.ruleForm.restrictionState,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "restrictionState", $$v)
                        },
                        expression: "ruleForm.restrictionState",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("collectionCenter.tudo"),
                          value: "all",
                        },
                        nativeOn: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleSelectAll2($event)
                          },
                        },
                      }),
                      _vm._l(_vm.StateList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.label, value: item.label },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("navbar.restrictionSiteId"),
                    prop: "siteIds",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        "remote-method": _vm.getSiteOptionList,
                        clearable: "",
                        filterable: "",
                        multiple: "",
                        remote: "",
                        "reserve-keyword": "",
                      },
                      on: {
                        change: _vm.handleSiteIds,
                        "visible-change": function ($event) {
                          return _vm.getSiteOptionList()
                        },
                      },
                      model: {
                        value: _vm.ruleForm.siteIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "siteIds", $$v)
                        },
                        expression: "ruleForm.siteIds",
                      },
                    },
                    _vm._l(_vm.restrictionSiteIds, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("navbar.RestrictedAccounts"),
                    prop: "userIds",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        "remote-method": _vm.getSiteAccounet,
                        clearable: "",
                        filterable: "",
                        multiple: "",
                        remote: "",
                        "reserve-keyword": "",
                      },
                      on: {
                        "visible-change": function ($event) {
                          return _vm.getSiteAccounet()
                        },
                      },
                      model: {
                        value: _vm.ruleForm.userIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "userIds", $$v)
                        },
                        expression: "ruleForm.userIds",
                      },
                    },
                    _vm._l(_vm.limitAccountList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.username, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("GlobalSetObj.Type"),
                    prop: "TypeList",
                  },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleTypeList },
                      model: {
                        value: _vm.ruleForm.TypeList,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "TypeList", $$v)
                        },
                        expression: "ruleForm.TypeList",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("navbar.dainziweilan"))),
                      ]),
                      _c("el-checkbox", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("navbar.qiangzhiyanzhengma"))),
                      ]),
                      _c("el-checkbox", { attrs: { label: 3 } }, [
                        _vm._v(_vm._s(_vm.$t("navbar.qiangzhiqinashou"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.ruleForm.TypeList.includes(1)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("navbar.deliveryDistance"),
                        prop: "deliveryDistance",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                          maxlength: "9",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "suffix",
                              fn: function () {
                                return [_c("span", [_vm._v("M")])]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          450250076
                        ),
                        model: {
                          value: _vm.ruleForm.deliveryDistance,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "deliveryDistance",
                              _vm._n($$v)
                            )
                          },
                          expression: "ruleForm.deliveryDistance",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ruleForm.TypeList.includes(2)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("navbar.smsTemplateId"),
                        prop: "smsTemplateId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.ruleForm.smsTemplateId,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "smsTemplateId", $$v)
                            },
                            expression: "ruleForm.smsTemplateId",
                          },
                        },
                        _vm._l(_vm.smsTemplateList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ruleForm.TypeList.includes(2)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("navbar.smsPushNode"),
                        prop: "smsPushNode",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.ruleForm.smsPushNode,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "smsPushNode", $$v)
                            },
                            expression: "ruleForm.smsPushNode",
                          },
                        },
                        _vm._l(_vm.pushNodeList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ruleForm.TypeList.includes(2)
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.pushMode"),
                        rules: [
                          {
                            required: true,
                            message: _vm.$t("GlobalSetObj.pleaseChoose"),
                            trigger: ["blur", "change"],
                          },
                        ],
                        prop: "pushMethod",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.ruleForm.pushMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "pushMethod", $$v)
                            },
                            expression: "ruleForm.pushMethod",
                          },
                        },
                        [
                          _c("el-option", {
                            key: 1,
                            attrs: {
                              label: _vm.$t("GlobalSetObj.sms"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            key: 2,
                            attrs: { value: 2, label: "Whatsapp" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.clickSubmit(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.clickSubmit(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }